import { IField } from "@/api/AppApi/services/builder/interfaces/interfaces";
import { useTranslation } from "@/hooks/localization/useTranslations";
import { useIsMobile } from "@/hooks/useIsMobile";
import { Col, Row } from "@/utils/bootstrap";
import { useEffect, useState } from "react";
import { FieldValues, UseFormReturn } from "react-hook-form";
import InputErrorMsg from "../../form-builder-helpers/InputErrorMsg";
import HookInput from "../hook-input/HookInput";
import AddressTypeButton, {
  AddressTypes,
} from "./address-type-btn/AddressTypeButton";

interface Props {
  form: UseFormReturn<FieldValues, any>;
  field: IField;
}
const AddressTypeBtns: React.FC<Props> = ({ form, field }) => {
  const mobile = useIsMobile();
  const t = useTranslation();
  const fConfig = field.configurations;
  const [addressName, setAddressName] = useState<AddressTypes>(
    AddressTypes.home,
  );
  const formValue = form.watch(fConfig.key);
  useEffect(() => {
    if (!!formValue) {
      if (formValue === "Home" || formValue === "المنزل")
        setAddressName(AddressTypes.home);
      else if (formValue === "Work" || formValue === "العمل")
        setAddressName(AddressTypes.work);
      else setAddressName(AddressTypes.other);
    }
  }, [formValue]);
  return (
    <>
      {!field.value && (
        <div>
          <div className="builder-item-label">{fConfig?.title}</div>
          <Row className="m-0" style={{ gap: mobile ? 8 : 16 }}>
            {Object.values(AddressTypes).map((addressType) => (
              <Col key={addressType} className="p-0 col-auto">
                <AddressTypeButton
                  btnType={addressType}
                  selected={addressName === addressType}
                  onClick={() => {
                    setAddressName(addressType);
                    form.setValue(
                      fConfig.key,
                      addressType !== AddressTypes.other ? t[addressType] : "",
                      {
                        shouldValidate: true,
                      },
                    );
                    form.clearErrors(fConfig.key);
                  }}
                />
              </Col>
            ))}
          </Row>
          {fConfig.hint && <div className="field-hint">{fConfig.hint}</div>}
          <InputErrorMsg
            errorMsg={form.formState?.errors?.[fConfig.key]?.message as string}
          />
        </div>
      )}
      {(field.value || addressName === AddressTypes.other) && (
        <HookInput
          label={fConfig.title}
          inputRegister={{
            ...form.register(fConfig.key, {
              required: fConfig.is_required ? t.this_field_is_required : "",
            }),
          }}
          errorMsg={form.formState.errors[fConfig.key]?.message as string}
        />
      )}
    </>
  );
};

export default AddressTypeBtns;
